export default {
	MAIN : "/",
	CATEGORY: ( id = ":id" ) => `/category/${ id }`,
	SUBCATEGORIES: ( id = ":id" ) => `/subcategories/${ id }`,
	SINGLE: ( category_id = ":category_id", id = ":id" ) => `/category/${ category_id }/post/${ id }`,
	ACCESSIBILITY_DECLARATION: '/accessibility-declaration',
	PRIVACY_POLICY: "/privacy-policy",
	NOT_FOUND: "/404"
}